import { cn } from "@/lib/utils";

interface FilterChipCountProps {
  count: number;
  selected: boolean;
}

export function FilterChipCount({ count, selected }: FilterChipCountProps) {
  if (count <= 0) {
    return null;
  }

  return (
    <span
      className={cn(
        "inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-full px-1.5 text-[11px] font-semibold tabular-nums leading-none",
        selected
          ? "bg-primary-100 text-primary-800"
          : "bg-surface-100 text-surface-600",
      )}
    >
      {count}
    </span>
  );
}
